"use client";

import { twMerge } from "tailwind-merge";

import { ForecastPeriod } from "@/features/analysis/overview/financial-forecast/services/financial-forecast-chart";
import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { getPeriodOptions } from "../data/period-options";

type Params = {
  period: ForecastPeriod;
};

export const PeriodToggle = ({ period }: Params) => {
  const { t } = useLang();
  const { updateQuery } = useUpdateQuery();
  const periodOptions = getPeriodOptions({ t });

  const togglePeriod = (value: ForecastPeriod) => {
    updateQuery({ name: "period", value });
  };

  return (
    <div className="flex w-fit items-center rounded-full border border-zinc-300 p-1">
      {periodOptions.map((periodOption) => (
        <button
          key={periodOption.value}
          className={twMerge(
            "rounded-full px-5 py-1 font-semibold text-zinc-600",
            periodOption.value === period && "bg-sky-600 text-white"
          )}
          onClick={() => togglePeriod(periodOption.value)}
        >
          <p className="text-sm">{periodOption.label}</p>
        </button>
      ))}
    </div>
  );
};
